import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=51090704&scoped=true&"
import script from "./LayoutCard.vue?vue&type=script&lang=js&"
export * from "./LayoutCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=51090704&prod&lang=scss&scoped=true&"
import style1 from "./LayoutCard.vue?vue&type=style&index=1&id=51090704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51090704",
  null
  
)

export default component.exports